export const lineHeight = {
  lineHeight: {
    lineHeightBase: '1rem', //16px
    lineHeightTight: '1.2rem',
    lineHeightNormal: '1.5rem',
    lineHeightRelaxed: '1.7rem',
    lineHeightMedium: '2.25rem',
    lineHeightLarge: '3.75rem',
  },
};
